import React, { useState, useEffect } from 'react';
import { User, LogOut } from 'lucide-react';
import { useMsal } from "@azure/msal-react";
import { useGraphApi } from '../hooks/useGraphApi';
import './Header.css';
import logo from './logo.png';

const Header = () => {
  const { instance, accounts } = useMsal();
  const { getUserPhoto, getUserProfile } = useGraphApi();
  const [userPhoto, setUserPhoto] = useState(null);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    const loadUserData = async () => {
      if (accounts.length > 0) {
        try {
          // Get user profile
          const profile = await getUserProfile();
          if (profile) {
            setUserProfile(profile);
          }
          const photo = await getUserPhoto();
          if (photo) {
            setUserPhoto(photo);
          }
        } catch (error) {
          console.error('Error loading user data:', error);
        }
      }
    };

    loadUserData();
  }, [accounts, getUserProfile, getUserPhoto]);

  const handleSignOut = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">          
          <div className="logo-container">
            <img
              src={logo}
              alt="Logo"
              className="logo-image"
              style={{ height: '1.5em', width: 'auto' }}
            />
          </div>
          <h1 className="header-title" style={{ display: 'inline', verticalAlign: 'middle' }}>
            DocuAssist
          </h1>
        </div>
        <div className="header-right">
          <div className="header-actions">
            <div className="user-profile">
              <div className="user-avatar">
                {userPhoto ? (
                  <img src={userPhoto} alt={userProfile?.displayName || 'User'} className="user-photo" />
                ) : (
                  <User size={20} />
                )}
              </div>
              <div className="user-info">
                <span className="user-name">{userProfile?.displayName || 'User'}</span>
                <span className="user-role">{userProfile?.mail || userProfile?.userPrincipalName || ''}</span>
              </div>
              <button onClick={handleSignOut} className="sign-out-btn">
                <LogOut size={18} />
                <span>Sign Out</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;